// ICU-style `{name}` interpolation, one pass, no nested braces.
// Missing vars resolve to '' and emit console.warn exactly once per call.
import type { InterpolationVars } from './types.js';

const VAR_RE = /\{([a-zA-Z_][a-zA-Z0-9_]*)\}/g;

export function interpolate(
  template: string,
  vars: InterpolationVars | undefined,
  keyForDiag: string,
): string {
  if (!template.includes('{')) return template;
  const missing: string[] = [];
  const result = template.replace(VAR_RE, (_match, name: string) => {
    if (!vars || !Object.prototype.hasOwnProperty.call(vars, name)) {
      missing.push(name);
      return '';
    }
    const v = vars[name];
    return v === undefined ? '' : String(v);
  });
  if (missing.length > 0) {
    // eslint rule allows console.warn by design.
    console.warn(
      `[@govard/i18n-core] Missing interpolation vars for "${keyForDiag}": ${missing.join(', ')}`,
    );
  }
  return result;
}
